import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import { Routing } from '../../../../../util/routes.util';
import { Breadcrumbs, Crumb } from '../../../../components/Breadcrumbs';
import Content from '../../../../components/Content';
import { Tab, Tabs } from '../../../../components/Tabs';
import ContainerTypesOverviewPane from './ContainerType/ContainerTypesOverviewPane';
import ContainerTableSettingsPane from './TableSettings/ContainerTableSettingsPane';

export default function ContaienrSettingsScreen() {
  return (
    <div className='flex flex-grow flex-col'>
      <Breadcrumbs>
        <Crumb path={Routing.stock.containers.overview()} text={t(TranslationKey.container).plural.upper} />
        <Crumb
          current
          path={Routing.stock.containers.settings.containerTypes()}
          text={t(TranslationKey.settings).singular.upper}
        />
      </Breadcrumbs>

      <Content>
        <Tabs>
          <Tab
            key={'container_types'}
            text={t(TranslationKey.containerType).plural.upper}
            path={Routing.stock.containers.settings.containerTypes()}
          />
          <Tab
            key={'table_settings'}
            text={t(TranslationKey.tableSettings).plural.upper}
            path={Routing.stock.containers.settings.tableSettings()}
          />
        </Tabs>

        <Routes>
          <Route path={'/container_types/*'} element={<ContainerTypesOverviewPane />} />
          <Route path={'/table_settings/*'} element={<ContainerTableSettingsPane />} />
        </Routes>
      </Content>
    </div>
  );
}
